// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Navigation_Navigation__JGKJN {
  width: max-content;
  height: 85vh;
}
.Navigation_Navigation__JGKJN ul {
  height: 100%;
}`, "",{"version":3,"sources":["webpack://./src/components/modules/app/components/Navigation/Navigation.module.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,YAAA;AACF;AACE;EACE,YAAA;AACJ","sourcesContent":[".Navigation {\n  width: max-content;\n  height: 85vh;\n\n  ul {\n    height: 100%;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Navigation": `Navigation_Navigation__JGKJN`
};
export default ___CSS_LOADER_EXPORT___;
